import { useEffect, useState } from "react";
import Api from "../../Api";
import { MoneyBlock, SelectBlock, TextBlock } from "../../parts/FormBlocks";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Category, EquipmentUI } from "../../types";

type EquipmentsFormProps = {
  equipment: EquipmentUI;
  onChange: (key: string) => (value: string | boolean) => void;
  onSubmit: () => Promise<void>;
  error: boolean;
};
const EquipmentsForm = ({
  equipment,
  onChange,
  onSubmit,
  error,
}: EquipmentsFormProps) => {
  const green = "bg-green-50 text-green-700 border-green-600";
  const red = "bg-red-50 text-red-700 border-red-600";

  const [categories, setCategories] = useState<Category[]>([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    Api.equipmentsListCategories().then(setCategories);
  }, []);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSaving(true);
    await onSubmit();
    setSaving(false);
  };

  return (
    <form className="flex flex-col gap-4" onSubmit={submit}>
      <TextBlock
        label={"Equipamento"}
        value={equipment.name}
        onChange={onChange("name")}
      />

      <SelectBlock
        label={"Categoria"}
        value={equipment.categoryUuid}
        onChange={onChange("categoryUuid")}
        options={categories.map((c) => ({ value: c.uuid, label: c.name }))}
      />

      <TextBlock
        label={"Marca"}
        value={equipment.brand}
        onChange={onChange("brand")}
        optional={true}
      />

      <MoneyBlock
        label={"Valor de venda"}
        value={equipment.price.toString()}
        onChange={onChange("price")}
      />

      <MoneyBlock
        label={"Valor de locação"}
        value={equipment.rent.toString()}
        onChange={onChange("rent")}
      />

      <hr />

      <div className="flex gap-2 justify-end">
        <span
          className={classNames(
            "border rounded-full py-1 px-4 flex gap-2 items-center font-mono lowercase cursor-pointer",
            { [green]: equipment.canSell },
            { [red]: !equipment.canSell }
          )}
          onClick={() => onChange("canSell")(!equipment.canSell)}
        >
          <span>Venda</span>
          <FontAwesomeIcon
            className="w-4"
            icon={equipment.canSell ? "check" : "xmark"}
          />
        </span>

        <span
          className={classNames(
            "border rounded-full py-1 px-4 flex gap-2 items-center font-mono lowercase cursor-pointer",
            { [green]: equipment.canRent },
            { [red]: !equipment.canRent }
          )}
          onClick={() => onChange("canRent")(!equipment.canRent)}
        >
          <span>Locação</span>
          <FontAwesomeIcon
            className="w-4"
            icon={equipment.canRent ? "check" : "xmark"}
          />
        </span>
      </div>

      <hr />

      {error && (
        <div className="text-sm text-red-700 font-bold">
          Erro ao salvar equipamento
        </div>
      )}

      <div className="text-right">
        <button
          className="rounded py-2 px-4 bg-sky-600 hover:bg-sky-500 font-extrabold text-white"
          disabled={saving}
        >
          Salvar
        </button>
      </div>
    </form>
  );
};

export default EquipmentsForm;
